/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-dialog-button-bar',
  template: '<ng-content></ng-content>',
  styleUrls: ['dialog-button-bar.component.scss'],
})
export class DialogButtonBarComponent {

}
